import { useCallback, useEffect, useState } from 'react';
import type { ProviderConfig } from '../../core/types';
import { readSecret } from '../providers/secretStore';
import { modelGateway } from '../modelGateway';
import { ensureBuiltinProviderKinds } from '../providers/registrySetup';

/** Fetch only the selected provider. Late responses cannot replace another provider's catalog. */
export function useProviderModels(provider: ProviderConfig | null): { models: string[]; loading: boolean; error: string | null; refresh: () => void } {
  const [revision, setRevision] = useState(0);
  const [state, setState] = useState<{ provider: ProviderConfig | null; models: string[]; loading: boolean; error: string | null }>({ provider: null, models: [], loading: false, error: null });
  const refresh = useCallback(() => setRevision(value => value + 1), []);
  useEffect(() => {
    if (!provider) return;
    let alive = true;
    setState({ provider, models: [], loading: true, error: null });
    void (async () => {
      try {
        ensureBuiltinProviderKinds();
        const apiKey = readSecret(provider.apiKeyRef);
        const adapter = modelGateway.createChatAdapter({ ...provider, ...(apiKey ? { apiKey } : {}), timeoutMs: 20000, retries: 0 });
        const models = [...new Set((await adapter.listModels()).map(model => model.trim()).filter(Boolean))];
        if (alive) setState({ provider, models, loading: false, error: null });
      } catch {
        if (alive) setState({ provider, models: [], loading: false, error: '模型列表加载失败，请检查提供商地址、登录状态和密钥后刷新' });
      }
    })();
    return () => { alive = false; };
  }, [provider, revision]);
  return { models: state.provider === provider ? state.models : [], loading: provider !== null && (state.provider !== provider || state.loading), error: state.provider === provider ? state.error : null, refresh };
}
